export default __webpack_public_path__ + "static/media/payroll.bef01a8a.svg";